import { Line, LineChart, ResponsiveContainer, XAxis } from 'recharts'

import { ReactComponent as ChartDotSVGOne } from '../../assets/images/chart-dot-1.svg'
import { ReactComponent as ChartDotSVGTwo } from '../../assets/images/chart-dot-2.svg'
import { ReactComponent as ChartDotSVGThree } from '../../assets/images/chart-dot-3.svg'
import { ReactComponent as ChartDotSVGFour } from '../../assets/images/chart-dot-4.svg'
import { ReactComponent as ChartDotSVGFive } from '../../assets/images/chart-dot-5.svg'
import { ReactComponent as ChartDotSVGSix } from '../../assets/images/chart-dot-6.svg'

const getChartConfigDict = (index) => {
  switch (index) {
    case 0:
      return {
        dotComponent: ChartDotSVGOne,
        color: '#2e933c'
      }
    case 1:
      return {
        dotComponent: ChartDotSVGTwo,
        color: '#009267'
      }
    case 2:
      return {
        dotComponent: ChartDotSVGThree,
        color: '#008F8E'
      }
    case 3:
      return {
        dotComponent: ChartDotSVGFour,
        color: '#0088AC'
      }
    case 4:
      return {
        dotComponent: ChartDotSVGFive,
        color: '#007EBB'
      }
    case 5:
      return {
        dotComponent: ChartDotSVGSix,
        color: '#1871B9'
      }
    default:
      return {
        dotComponent: ChartDotSVGOne,
        color: '#2e933c'
      }
  }
}

const ChartDot = (props) => {
  const { cx, cy, configIndex } = props

  const ChartDotComponent = getChartConfigDict(configIndex).dotComponent

  return (
    <ChartDotComponent
      x={cx - 12}
      y={cy - 12}
      height={24}
      width={24}
    />)
}

export default function CheckinChart (props) {
  const { chartData, dataKey, configIndex } = props

  return (
    <ResponsiveContainer>
      <LineChart
        data={chartData}

      >
        <Line
          type='monotone'
          stroke={getChartConfigDict(configIndex).color}
          strokeWidth={4}
          dataKey={dataKey}
          dot={<ChartDot configIndex={configIndex} height={24} />}
        />
        <XAxis
          dataKey='name'
          interval={0}
        />

      </LineChart>
    </ResponsiveContainer>
  )

}
